import DeckPage, { getServerSideProps as getDeckServerSideProps } from 'pages/decks/[id]'

export default DeckPage

export const getServerSideProps = getDeckServerSideProps
